import { HttpInjector } from '@/cowboy/http/HttpInjector'
import { RecipientInfoResponse } from '@/cowboy/recipient/object/RecipientInfoResponse'

export class RecipientApi extends HttpInjector {
  /**
   * Fetch the recipients contact info the current RewardLink
   * @return {Promise<RecipientInfoResponse>}
   */
  static async fetchRecipientInfo () {
    const response = await this.$http.get(`/sv/${this.codeVersion.requestCode}/recipient-info`, { params: { urlVersion: this.codeVersion.urlVersion } })
    return this.cast(response.data, RecipientInfoResponse)
  }
}
